import React from 'react';
import {Box, Container} from "@mui/material";
import {useNavigate} from "react-router-dom";
import LoginForm from "./LoginForm";
import {LoginBlock} from './style';
import {useTypedSelector} from "../../store";

const AuthPage = () => {
    const {isAuth} = useTypedSelector(state => state.auth)
    const navigate = useNavigate()
    React.useEffect(() => {
        if (isAuth) {
            navigate('/app')
        }

    }, [isAuth])


    return (
        <LoginBlock>
            <Container
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",

                }}
            >
                <Box
                    sx={{
                        display: { lg: "none", xs: "block" },
                    }}
                >
                </Box>
                <LoginForm />
                <Box
                    sx={{
                        display: { lg: "block", xs: "none" },
                    }}
                >
                </Box>
            </Container>
        </LoginBlock>
    );
};

export default AuthPage;